import React from 'react'
import { useTranslation } from 'react-i18next'
import kebabCase from 'lodash/kebabCase'
import { TextInput } from '../../../../../common/inputs/textInput/TextInput'
import { FieldProps } from '../../../../../../@types/types'
import { ApiSearchDataScreenValidationResult } from '../../../../../../@types/validation-types'

type SearchFieldAdditionalProps = {
  propertyName: 'searchField1' | 'searchField2' | 'searchField3'
}

export const ApiSearchField: React.FC<FieldProps<ApiSearchDataScreenValidationResult> & SearchFieldAdditionalProps> = ({
  insertionData,
  validationMessages,
  screenName,
  onChange,
  propertyName,
}) => {
  const { t } = useTranslation()

  return (
    <div className='grid-item one-whole'>
      <TextInput
        id={kebabCase(propertyName)}
        propertyName={propertyName}
        placeholder=''
        label={t(`wizard.screen.apiSearchData.${propertyName}`, propertyName)}
        value={insertionData[propertyName] as string}
        type='text'
        maxLength={15}
        showMaxLengthLabel={true}
        errors={validationMessages?.[propertyName] ?? []}
        doOnFieldChange={(property, value) => {
          onChange({ screen: screenName, property }, value)
        }}
      />
    </div>
  )
}
